import { memo, useState, useEffect, useContext, useRef } from "react";
import { Flex, HelpIcon } from "@pancakeswap/uikit";
import { useDispatch, useSelector } from "react-redux";
import '@rainbow-me/rainbowkit/styles.css';
import {
  MainTokenConfig,
  RouterConfig,
  RPCLIST,
  newSwapConfig,
  zeroAddress,
  NOVIP_AMOUNT,
} from "@/config";
import {
  chainId,
  chainIdChange,
  pairToken,
  pairTokenChange,
  router,
  routerChange,
  rpc,
  rpcChange,
  token,
  tokenChange,
  universalRouterChange,
  permit2Change,
  v3FactoryChange,
  quoterChange,
  feeV3Change,
  feeV3,
  gasChange,
  spenTokenChange,
  spenToken,
  mainConfig,
  mainConfigChange,
  vip,
} from "@/store";
import { AppContext } from "@/context";
import { RouterType, TokenType } from "@/store/type";
import { BotHeader } from "../style";
import { ContentItem } from "../Content/style";
import DropDown, { Dropdown, DropdownItem, SelectBox } from "@/components/DropDown";
import { storageUtil } from "@/hooks/useStorage";
import { useAccount, useChainId, useSwitchChain } from "wagmi";
import getTokenInfo from "@/utils/getTokenInfo";
import { Notification } from "@/components";
import { isIntegerInput } from "@/utils";
import { useProviderInstance } from "@/context/ProviderContext";
import { isAddress } from "viem";
import { Input } from "@/components/Input";
import TextReact from "@/components/Text";
import { FormContainer, FormTitle, RowTwoCol, FormItem, InputWrapper, ClearButton, SelectWrapper, VipTip, FormItemFull, FormLabel } from "./style";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ChainIdConfig } from "@/utils/wagmi";
import TokenSelector, { Token } from "@/components/TokenSelector";
export const isPaidNode = (rpc: string) => {
  return rpc.includes("rpc.gtokentool.com");
};
function App() {
  const { switchChain } = useSwitchChain();
  const { Lang } = useContext(AppContext);
  const dispatch = useDispatch();
  const chainIds = useChainId();

  const _chainId = useSelector(chainId);
  const _vip = useSelector(vip);
  const _router = useSelector(router);
  console.log('_router::: ', _router);
  const { isConnected } = useAccount();
  const provider = useProviderInstance();

  const stored = storageUtil.get("user");
  const globalTargetData = stored?.globalTargetData || {};

  const rpcsArray = RPCLIST.find((item) => item.id === _chainId)?.rpcs || [];
  const nodeOptions = rpcsArray.map((rpc, index) => {
    const isPaid = isPaidNode(rpc);
    const label = _vip
      ? `${isPaid ? "💰 收费节点" : "🆓 免费节点"} - ${rpc}` // VIP：直接显示RPC链接，无额外文字
      : rpc;
    return {
      id: `rpc_${index}`,
      label: label, // 列表显示带标识
      value: rpc, // 核心：value存纯RPC链接（选的时候取这个）
    };
  });

  const [V3Fee, setV3Fee] = useState<string>(globalTargetData.feeV3 || "0.25");
  const [rpc, setRpc] = useState(globalTargetData.rpc || rpcsArray[0]);
  // 根据钱包切换公链
  useEffect(() => {
    if (chainIds) {
      const exist = ChainIdConfig.some((item) => item.id === chainIds);
      if (exist) {
        dispatch(chainIdChange(chainIds));
      }
    }
  }, [chainIds]);

  // 公链名称
  const [chainIdLabel, setChainIdrLabel] = useState("");
  useEffect(() => {
    getChainIdLabel();
    getRouterConfig();
  }, [_chainId, _router.label]);
  const [searchParams] = useSearchParams();

  const getChainIdLabel = () => {
    if (ChainIdConfig.length > 0) {
      const urlChainId = searchParams.get('chainId');
      const result = ChainIdConfig.filter((item) => item.id === Number(urlChainId));
      if (result[0]) {
        dispatch(chainIdChange(result[0].id));
        setChainIdrLabel(result[0].label);
      } else {
        // dispatch(chainIdChange(_chainId));
        const result1 = ChainIdConfig.filter((item) => item.id === Number(_chainId));
        setChainIdrLabel(result1[0].label);
      }
    }
  };
  const navigate = useNavigate();
  const location = useLocation();

  // 显示更多公链
  const moreChainIdChange = (item: ChainIdConfigType) => {
    if (item) {
      dispatch(chainIdChange(item.id));
      const params = new URLSearchParams(searchParams.toString());
      params.set('chainId', String(item.id));
      const newPath = `${location.pathname}?${params.toString()}`;
      navigate(newPath, { replace: true });
      if (isConnected && switchChain) {
        switchChain({ chainId: item.id });
      }
      const newTokens: TokenType = { address: "", symbol: "", decimals: 18 };
      dispatch(tokenChange(newTokens));
    }
    if (_router.label.includes("V4")) {
      const newToken = {
        address: zeroAddress,
        symbol: MainTokenConfig[item.id][0].symbol,
        decimals: MainTokenConfig[item.id][0].decimals,
      };
      dispatch(spenTokenChange(newToken));
    } else {
      dispatch(spenTokenChange(MainTokenConfig[item.id][0]));
    }
    dispatch(gasChange(""));
  };

  // 路由config
  const _mainConfig = useSelector(mainConfig);

  const [routerConfig, setRouterConfig] = useState<RouterType[]>([]);
  // console.log(rpcConfig, 'rpcConfig');
  // console.log(_router.label, '_router.label');
  const getRouterConfig = () => {
    const config = RouterConfig[_chainId];
    let hitRouter: RouterType;
    if (config) {
      console.log('config::: ', config);
      setRouterConfig(config);
      const index = config.findIndex((item) => item.address == _router.address);
      if (index < 0) {
        // 本地存的 router 地址在这条链上已经不存在了，退回当前链的第一条
        hitRouter = config[0];
        dispatch(routerChange(hitRouter));
      } else {
        hitRouter = config[index];
        // 旧版本里交易所在 RouterConfig 中改过名字（例如 pancakeSwap -> pancakeSwap V2），
        // 地址没变，所以只按地址校验会一直匹配、本地存的旧 label 永远不被纠正。
        // 这里把 label 同步成当前版本，避免下面按 label 找不到交易配置。
        if (hitRouter.label !== _router.label) dispatch(routerChange(hitRouter));
      }
    } else {
      setRouterConfig([]);
      hitRouter = { label: "", address: "" };
      dispatch(routerChange(hitRouter));
    }

    //需要修改
    const res = newSwapConfig[_chainId]?.find(
      // 用 RouterConfig 里命中的那条 label 匹配，而不是本地存储里的 _router.label：
      // 交易所改名后本地 label 会对不上，四个地址会一直是空字符串，
      // 交易时就会抛 viem 的 Address "0x" is invalid.
      (item) => item.label === hitRouter.label,
    );
    if (res) {
      const universalRouter = res.universalRouter || "";
      dispatch(universalRouterChange(universalRouter));
      const _permit2 = res.permit || "";
      dispatch(permit2Change(_permit2));
      const v3FactoryAddress = res.v3FactoryContract || "";
      dispatch(v3FactoryChange(v3FactoryAddress));
      const quoterAddress = res.quoter || "";
      // console.log(quoterAddress, 'quoterAddress');
      dispatch(quoterChange(quoterAddress));
    } else {
      console.warn(
        `[router] 未找到 ${_chainId} / ${hitRouter.label} 的交易配置（newSwapConfig），` +
          `UniversalRouter 等地址会为空，请检查配置表`,
      );
    }
  };

  const moreSwapBtnClick = (item: RouterType) => {
    dispatch(routerChange(item));
    if (item.label === "four" || item.label === "flap") {
      dispatch(
        mainConfigChange({ ..._mainConfig, isBuyAmount: 0, isSellAmount: 1 }),
      );
    }
    if (item.label.includes("V4") && _spenToken.symbol === "BNB") {
      const newToken = {
        address: zeroAddress,
        symbol: _spenToken.symbol,
        decimals: _spenToken.decimals,
      };
      dispatch(spenTokenChange(newToken));
    } else {
      const matchedToken = MainTokenConfig[_chainId]?.find(
        (token) => token.symbol === _spenToken.symbol,
      );
      const newToken = {
        address: matchedToken.address,
        symbol: matchedToken.symbol,
        decimals: matchedToken.decimals,
      };
      dispatch(spenTokenChange(newToken));
    }
  };

  const moreRPCBtnClick = (item) => {
    dispatch(rpcChange(item.value));
    setRpc(item.value);
  };
  const [tokenAddress, setTokenAddress] = useState("");

  const tokenAddressChange = async (e: { target: { value: string } }) => {
    const newTokens: TokenType = { address: "", symbol: "", decimals: 18 };
    const raw = e.target.value;
    const address = raw.trim();
    // 输入框照常回显用户输入，但**不能**一输入就把 store 里的代币清空：
    // 旧实现是无条件 dispatch(tokenChange(newTokens))，机器人运行中改一下输入框
    // （或代币识别失败）就会让交易拿到空代币地址，to0xString('') 会变成 '0x'，
    // 进而抛 viem 的 Address "0x" is invalid. 只有用户真的清空输入框时才清空代币。
    setTokenAddress(raw);

    if (!address) {
      // 用户删除了输入，清空 token
      dispatch(tokenChange(newTokens));
      setTokenAddress("");
      return;
    }
    setTokenAddress("代币识别中..."); // 先同步更新输入框
    if (!isAddress(address)) {
      // 非法地址，先不报错，只更新输入框
      return;
    }

    try {
      const { symbol_, decimals_ }: any = await getTokenInfo(address, provider);
      const newToken: TokenType = {
        address,
        symbol: symbol_,
        decimals: decimals_,
      };
      dispatch(tokenChange(newToken));
      setTokenAddress(address); // 先同步更新输入框
    } catch (err) {
      console.log(err, "err");
      // 识别失败时不要清空代币（清空后刷单会拿到空地址，抛 Address "0x" is invalid.），
      // 同时把输入框还原成真正在用的地址，避免界面显示的币和实际交易的币不一致
      setTokenAddress(_token?.address ?? "");
      Notification.Error(
        "代币识别错误，请检查公链和代币是否匹配，以及网络信号",
      );
    }
  };
  const _token = useSelector(token);
  useEffect(() => {
    setTokenAddress(_token?.address);
  }, [_token]);

  const _spenToken = useSelector(spenToken);
  useEffect(() => {
    const rpcsArrayNew = RPCLIST.find((items) => items.id === _chainId).rpcs;
    dispatch(rpcChange(rpcsArrayNew[0]));
    setRpc(rpcsArrayNew[0]);
  }, [_chainId]);


  type ChainIdConfigType = {
    label: string;
    id: number;
  };

  const V3FeeChange = (e: string) => {
    if (!isIntegerInput(e, true)) return Notification.Error("请输入小数");
    setV3Fee(e);
    dispatch(feeV3Change(e));
  };

  return (
    <FormContainer>
      <FormTitle>{"交易对参数配置"}</FormTitle>
      {/* 第 1 行：公链 + 交易所 */}
      <RowTwoCol>
        <FormItem>
          <FormLabel>{Lang.SelectChain}</FormLabel>
          <DropDown
            label=""
            value={chainIdLabel}
            options={ChainIdConfig}
            onSelect={moreChainIdChange}
          />
        </FormItem>

        <FormItem>
          <FormLabel>{Lang.SelectRouter}</FormLabel>
          <DropDown
            label=""
            value={_router.label}
            options={routerConfig}
            onSelect={moreSwapBtnClick}
          />
        </FormItem>
      </RowTwoCol>

      {/* 第 2 行：代币地址 */}
      <FormItemFull>
        <FormLabel>{Lang.contractAddress}</FormLabel>
        <InputWrapper>
          <Input
            value={tokenAddress}
            onChange={tokenAddressChange}
            name="token"
          />
          {tokenAddress && (
            <ClearButton
              onClick={() => {
                const newTokens: TokenType = { address: "", symbol: "", decimals: 18 };
                dispatch(tokenChange(newTokens));
                setTokenAddress("");
              }}
            >
              <img src="/close.png" alt="" />
            </ClearButton>
          )}
        </InputWrapper>
      </FormItemFull>

      {/* 第 3 行：池子类型 + 池子费用级别 */}
      <RowTwoCol>
        <FormItem>
          <FormLabel>{Lang.poolType}</FormLabel>
          <TokenSelector onSelect={(token: Token | null) => { if (token) { dispatch(spenTokenChange(token));console.log('token::: ', token); } }} token={_spenToken}></TokenSelector>
          
        </FormItem>

        {/V3/.test(_router.label) && (
          <FormItem>
            <FormLabel>{Lang.FeeTier}</FormLabel>
            <SelectWrapper className="pairtype">
              <SelectBox>
                <Input
                  autoComplete="off"
                  value={V3Fee}
                  onChange={(e) => V3FeeChange(e.target.value)}
                  placeholder="0.1"
                />
                <Dropdown>
                  {getV3FeeOptions(_chainId, _router.label).map((item, index) => (
                    <DropdownItem key={index} onClick={() => V3FeeChange(item.value)}>
                      {item.label}
                    </DropdownItem>
                  ))}
                </Dropdown>
              </SelectBox>
            </SelectWrapper>
          </FormItem>
        )}
      </RowTwoCol>

      {/* 第 4 行：RPC Node URL */}
      <FormItemFull>
        <FormLabel>{Lang.Node || "RPC Node URL"}</FormLabel>
        <DropDown
          label=""
          value={rpc}
          options={nodeOptions}
          onSelect={moreRPCBtnClick}
        />
        {_vip && (
          <VipTip>
            {rpc === nodeOptions[0].value && isPaidNode(rpc)
              ? `当前选择：收费节点，将收取${NOVIP_AMOUNT[_chainId] / 10} ${MainTokenConfig[_chainId][0]?.symbol} / 笔交易`
              : "当前选择：免费节点，不收取额外费用"}
          </VipTip>
        )}
      </FormItemFull>
    </FormContainer>
  );
}

export default memo(App);

export function getV3FeeOptions(chainId: number, label: string) {
  // 基础费率选项（所有场景都包含）
  const baseOptions = [
    { label: "0.01", value: "0.01" },
    { label: "0.05", value: "0.05" },
  ];

  let middleOption = [];
  // 核心逻辑：分场景处理中间费率
  if (chainId === 56 || chainId === 97) {
    // 场景1：BSC主网/测试网 → 只显示0.25
    middleOption = [{ label: "0.25", value: "0.25" }, { label: "0.3", value: "0.3" }];
  } else if (chainId === 137 || label.includes("Uniswap V3")) {
    // 场景2：chainId=137 或 label包含v3 → 只显示0.3
    middleOption = [{ label: "0.3", value: "0.3" }];
  } else {
    // 场景3：其他链 → 显示0.25 + 0.3
    middleOption = [
      { label: "0.25", value: "0.25" },
      { label: "0.3", value: "0.3" },
    ];
  }

  // 合并所有选项，最后追加1%的费率
  return [...baseOptions, ...middleOption, { label: "1", value: "1" }];
}
